import React, { PropsWithChildren } from 'react';

import PlayerCardWrapper from '../player-card-wrapper/player-card-wrapper';
import { makeClassNames } from '../../../utils/styles';
import './football-team-content.scss';

const classNames = () =>
  makeClassNames({
    content: 'football-team-content',
  });

const cn = classNames();

export interface IFootballTeamContent {
  playerTeamColor: string;
}

const FootballTeamContent = (props: PropsWithChildren<IFootballTeamContent>) => {
  const { playerTeamColor, children } = props;

  return (
    <PlayerCardWrapper playerTeamColor={playerTeamColor} hasHeadShot={false}>
      <div className={cn.content}>{children}</div>
    </PlayerCardWrapper>
  );
};

export default FootballTeamContent;
